import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";
import deprecated from "./deprecated";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  deprecated,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.99">
          <path d="M19 2.69995H5.00001C3.50001 2.69995 2.20001 3.99995 2.20001 5.49995V19.5C2.20001 21 3.40001 22.2999 5.00001 22.2999H19C20.5 22.2999 21.8 21.1 21.8 19.5V5.49995C21.8 3.99995 20.5 2.69995 19 2.69995ZM5.00001 4.29995H19C19.7 4.29995 20.2 4.89995 20.2 5.49995V8.09995H3.80001V5.49995C3.80001 4.79995 4.30001 4.29995 5.00001 4.29995ZM19 20.7H5.00001C4.30001 20.7 3.80001 20.1 3.80001 19.5V9.59995H20.3V19.5C20.2 20.2 19.7 20.7 19 20.7Z" />
          <path d="M9.5 12H6.5C5.9 12 5.5 12.4 5.5 13V17C5.5 17.6 5.9 18 6.5 18H9.5C10.1 18 10.5 17.6 10.5 17V13C10.5 12.4 10.1 12 9.5 12Z" />
          <path d="M16 15.7H13C12.7 15.7 12.4 16 12.4 16.3C12.4 16.6 12.7 16.9 13 16.9H16C16.3 16.9 16.6 16.6 16.6 16.3C16.6 16 16.3 15.7 16 15.7Z" />
          <path d="M18 13.2H13C12.7 13.2 12.4 13.5 12.4 13.8C12.4 14.1 12.7 14.4 13 14.4H18C18.3 14.4 18.6 14.1 18.6 13.8C18.6 13.5 18.3 13.2 18 13.2Z" />
          <path d="M5.8 6.9999C6.24183 6.9999 6.6 6.64173 6.6 6.1999C6.6 5.75807 6.24183 5.3999 5.8 5.3999C5.35817 5.3999 5 5.75807 5 6.1999C5 6.64173 5.35817 6.9999 5.8 6.9999Z" />
          <path d="M8.20002 6.9999C8.64185 6.9999 9.00002 6.64173 9.00002 6.1999C9.00002 5.75807 8.64185 5.3999 8.20002 5.3999C7.7582 5.3999 7.40002 5.75807 7.40002 6.1999C7.40002 6.64173 7.7582 6.9999 8.20002 6.9999Z" />
          <path d="M10.8 6.9999C11.2418 6.9999 11.6 6.64173 11.6 6.1999C11.6 5.75807 11.2418 5.3999 10.8 5.3999C10.3582 5.3999 10 5.75807 10 6.1999C10 6.64173 10.3582 6.9999 10.8 6.9999Z" />
        </g>
      </svg>
    ),
  },
});
